import { render, staticRenderFns } from "./horizontal_wizard.vue?vue&type=template&id=b0ec9b22&"
import script from "./horizontal_wizard.vue?vue&type=script&lang=js&"
export * from "./horizontal_wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports